import { useState, useRef } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { FaDownload, FaCopy, FaCheck, FaDesktop, FaMobileAlt } from 'react-icons/fa'
import './QRCodeGenerator.css'

function QRCodeGenerator() {
  const [text, setText] = useState('')
  const [qrCode, setQrCode] = useState('https://example.com')
  const [copied, setCopied] = useState(false)
  const [size, setSize] = useState(256)
  const qrRef = useRef(null)

  const generateQRCode = () => {
    if (text.trim()) {
      setQrCode(text)
    }
  }

  const downloadQRCode = () => {
    const canvas = document.querySelector('#qr-code svg')
    if (canvas) {
      const svgData = new XMLSerializer().serializeToString(canvas)
      const canvas2 = document.createElement('canvas')
      const ctx = canvas2.getContext('2d')
      const img = new Image()
      img.onload = () => {
        canvas2.width = size
        canvas2.height = size
        ctx.fillStyle = 'white'
        ctx.fillRect(0, 0, size, size)
        ctx.drawImage(img, 0, 0, size, size)
        const link = document.createElement('a')
        link.download = 'qrcode.png'
        link.href = canvas2.toDataURL()
        link.click()
      }
      img.src = 'data:image/svg+xml;base64,' + btoa(svgData)
    }
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(qrCode).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="qr-generator">
      <div className="platform-notice">
        <span className="platform-support">
          <FaDesktop /> <FaMobileAlt /> 支持电脑端和移动端使用
        </span>
      </div>

      <div className="qr-generator-content">
        <div className="input-section">
          <label htmlFor="qr-text" className="input-label">
            输入内容生成二维码
          </label>
          <textarea
            id="qr-text"
            className="qr-input"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="输入网址、文本或任何内容..."
            rows={4}
          />
          <div className="input-actions">
            <div className="size-selector">
              <label htmlFor="size">尺寸:</label>
              <select
                id="size"
                value={size}
                onChange={(e) => setSize(Number(e.target.value))}
              >
                <option value={128}>128px</option>
                <option value={256}>256px</option>
                <option value={512}>512px</option>
              </select>
            </div>
            <button
              className="generate-btn"
              onClick={generateQRCode}
              disabled={!text.trim()}
            >
              生成二维码
            </button>
          </div>
        </div>

        <div className="output-section">
          <div className="qr-preview" id="qr-code">
            <QRCodeSVG
              value={qrCode}
              size={size}
              level="H"
              includeMargin={true}
            />
          </div>
          
          <div className="qr-info">
            <p className="qr-text-preview">
              <strong>内容:</strong> {qrCode.length > 50 ? qrCode.substring(0, 50) + '...' : qrCode}
            </p>
          </div>
          
          <div className="qr-actions">
            <button className="action-btn download" onClick={downloadQRCode}>
              <FaDownload /> 下载图片
            </button>
            <button className="action-btn copy" onClick={copyToClipboard}>
              {copied ? <><FaCheck /> 已复制</> : <><FaCopy /> 复制内容</>}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default QRCodeGenerator